export default function initActivityFlip() {
    const cards = document.querySelectorAll('[data-activity-card].activities-section__activity--has-details');

    if (cards.length === 0) return;

    const getActiveClass = (card) => {
        const animation = card.dataset.activityAnimation;
        if (animation === 'flip') return 'is-flipped';
        if (animation === 'spiral') return 'is-spiral';
        return 'is-open';
    };

    const isCardOpen = (card) => {
        const activeClass = getActiveClass(card);
        return card.classList.contains(activeClass);
    };

    const closeAllCards = (except = null) => {
        cards.forEach(card => {
            if (card !== except && isCardOpen(card)) {
                card.classList.remove(getActiveClass(card));
            }
        });
    };

    cards.forEach(card => {
        const front = card.querySelector('.activities-section__activity__front');
        const closeButton = card.querySelector('.activities-section__activity__close');
        const activeClass = getActiveClass(card);

        if (front) {
            front.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                closeAllCards(card);
                card.classList.add(activeClass);
            });
        }

        if (closeButton) {
            closeButton.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                card.classList.remove(activeClass);
            });
        }
    });

    document.addEventListener('click', (e) => {
        if (!e.target.closest('[data-activity-card]')) {
            closeAllCards();
        }
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            closeAllCards();
        }
    });
}
